// extracted by mini-css-extract-plugin
module.exports = {"unionLink":"UnionLink_unionLink__3iWys"};